export default {
    updatePropertyModal({ state, commit }, data) {
        const { key, title, description, props } = data;
        const updated = [];
        return new Promise((resolve, reject) => {
            if (!state.modalsSettings[key]) {
                reject('Данное модальное окно отсутствует в приложении!');
            }
            commit('UPDATE_PROPERTY_MODAL', data);
            if (title) {
                if (state.modalsSettings[key].title === title) {
                    updated.push(true);
                } else {
                    updated.push(false);
                }
            }
            if (description) {
                if (state.modalsSettings[key].description === description) {
                    updated.push(true);
                } else {
                    updated.push(false);
                }
            }
            if (props) {
                if (state.modalsSettings[key].props === props) {
                    updated.push(true);
                } else {
                    updated.push(false);
                }
            }
            if (!updated.includes(false)) {
                resolve(state.modalsSettings[key]);
            }
            reject(`Ошибка обновления настроек модального окна`);
        });
    },
    openModal({ state, commit }, keyLayout) {
        new Promise((resolve, reject) => {
            commit('SET_LAYOUT_MODAL', keyLayout);
            if (state.modalLayout.layout === state.modalsSettings[keyLayout].layout) {
                resolve(state.modalLayout);
            }
            reject('Ошибка установки layout');
        })
            .then(response => {
                if (response) {
                    commit('OPEN_MODAL');
                }
            })
            .catch(error => {
                console.error(error);
            });
    },
    closeModal({ commit }) {
        commit('CLOSE_MODAL');
        commit('SET_LAYOUT_MODAL', null);
    },
}